export * from './ai-two-offers-lock'
